import { CRow } from "@coreui/react";
import { CButton, CCol } from "@coreui/react";
import React, { useState } from "react";
// import "./LoginWithPassword.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo1024 from "../../../assets/logo1024.png";
import Loader from "../../../Components/loader/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import bg_image from "../../../assets/evacassets/image/bg_gradient.png";
import logo_new from "../../../assets/evacassets/image/logo.png";
import CustomInput from "../../../Components/New_Components/CustomInput";
import CustomButton from "../../../Components/New_Components/CustomButton";
import ForgotPasswordModal from "../../../Components/New_Components/ForgotPasswordModal";

const LoginWithPassword = () => {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const notify = (message) => toast(message);
  const [theme, setTheme] = useState(
    window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"
  );

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    console.log("e  " + e);
    e.preventDefault();
    setLoading(true);
    if (phone.length < 10 || phone.length > 10) {
      if (phone === "") {
        notify("Phone Number is required", {
          type: "error",
          theme: theme === "dark" ? "light" : "dark",
        });
      } else {
        notify("Please enter valid phone number", {
          type: "error",
          theme: theme === "dark" ? "light" : "dark",
        });
      }
    } else if (password === "") {
      notify("Password is required", {
        type: "error",
        theme: theme === "dark" ? "light" : "dark",
      });
    } else {
      console.log("inlogin else");
      var raw = JSON.stringify({
        phone: phone,
        password: password,
      });
      setLoading(true);
      console.log("raw" + raw);
      const proxyUrl = "/api/loginPassword";
      axios
        .post(proxyUrl, raw, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((response) => {
          console.log(JSON.stringify(response));
          if (response.status === 202) {
            setLoading(false);
            notify("Successfully Logged In", {
              type: "success",
              theme: theme === "dark" ? "light" : "dark",
            });
            localStorage.setItem("user", JSON.stringify(response.data.profile));
            localStorage.setItem("token", response.data.profile.userId);
            sessionStorage.setItem("token", response.data.profile.userId);
            localStorage.setItem("Jtoken", response.data.token);
            sessionStorage.setItem("Jtoken", response.data.token);
            localStorage.setItem(
              "profilePicture",
              response.data.profile.profilePicture
            );

            localStorage.setItem("phone", phone);
            const current = new Date();
            const ExTime = current.getDate() + 7;
            localStorage.setItem("ExTime", ExTime);
            console.log("Response before dashboard");
            window.token = "token";

            navigate("/dashboard");
            // setLoading(true);
          } else {
            setLoading(false);
            notify("Something went wrong", {
              type: "error",
              theme: theme === "dark" ? "light" : "dark",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          if (e.response.data.err) {
            setLoading(false);
            notify(e.response.data.err, {
              type: "error",
              theme: theme === "dark" ? "light" : "dark",
            });
          } else {
            setLoading(false);
            notify("Something went wrong", {
              type: "error",
              theme: theme === "dark" ? "light" : "dark",
            });
          }
        });
    }
  };

  const [showForgotModal, setShowForgotModal] = useState(false);

  return (
    <div className="min-h-screen w-full flex flex-col md:flex-row font-roboto">
      <ToastContainer />
      <div className="w-full md:w-1/2 flex flex-col justify-center py-10">
        <div className="p-4 lg:px-14 lg:mx-24">
          <h1 className="font-bold mb-4">Get Started</h1>

          <form onSubmit={handleSubmit} className="space-y-4">
            <CustomInput
              id="phone"
              label="Phone Number"
              type="tel"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="Enter phone number"
              minLength={10}
              maxLength={10}
              required
            />

            <CustomInput
              id="password"
              label="Password"
              type="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="Enter password"
              required
              showToggle={true}
            />

            <div className="text-right mt-1 mb-2">
              <button
                type="button"
                // onClick={() => navigate("/forgotPassword")}
                onClick={() => setShowForgotModal(true)}
                className="text-sm text-blue-600 hover:underline"
              >
                Forgot password
              </button>
            </div>

            <CustomButton
              title="Login"
              disabled={loading}
              onPress={handleSubmit}
            />
          </form>

          {/* Extra Links */}
          <div className="text-sm text-center text-gray-600 space-y-4 mt-4">
            <div className="flex items-center gap-4 text-gray-500">
              <hr className="flex-grow border-gray-600" />
              <span className="text-sm font-medium">OR</span>
              <hr className="flex-grow border-gray-600" />
            </div>

            {/* Login with OTP */}
            <p>
              <CustomButton
                title="Login with OTP"
                disabled={loading}
                onPress={() => navigate("/loginwithotp")}
                filledColor="transparent"
                textColor="#000"
              />
            </p>

            {/* Sign up */}
            <p>
              Don't have an account?{" "}
              <button
                type="button"
                onClick={() => navigate("/register")}
                className="text-blue-600 hover:underline"
              >
                Sign up
              </button>
            </p>
          </div>
        </div>
      </div>

      <div
        className="hidden md:flex w-full md:w-1/2 relative bg-cover bg-center items-center justify-center"
        style={{ backgroundImage: `url(${bg_image})` }}
      >
        <div className="bg-white rounded-xl p-8 py-14 w-[90%] md:w-[60%] mx-auto">
          <div className="w-[80%] text-black text-justify space-y-4">
            <div className="mb-6">
              <img src={logo_new} alt="Logo" className="w-40" />
            </div>
            <h2 className="text-3xl font-semibold text-left">
              Manage Your <br /> Charging Ecosystem
            </h2>
            <p className="text-sm md:text-base text-gray-600 text-left">
              Pyramid Home Charge lets you add and monitor multiple chargers
              from one place. Stay connected, organized, and in control.
            </p>
          </div>
        </div>
      </div>

      {showForgotModal && (
        <ForgotPasswordModal onClose={() => setShowForgotModal(false)} />
      )}
    </div>
  );
};

export default LoginWithPassword;
